import React, { useEffect, useRef, useState } from 'react';
import clsx from 'clsx';

import classes from './video.module.scss';

import PlaySVG from '@/assets/svg/play.svg';
import PauseSVG from '@/assets/svg/pause.svg';
import SoundOnSVG from '@/assets/svg/sound-on.svg';
import SoundOffSVG from '@/assets/svg/sound-off.svg';
import { useStorage } from '@/models/Storage';
import { observer } from 'mobx-react';

export const Video = observer(({ source, forcedPause = false, poster, type = 'default' }) => {
    const videoRef = useRef(null);
    const [paused, setPaused] = useState(true);
    const [muted, setMuted] = useState(true);
    const [showVideo, setShowVideo] = useState(false);

    const { soundEmitter, setSoundEmitter } = useStorage();

    const togglePlay = (e) => {
        e.stopPropagation();

        if (!showVideo) setShowVideo(true);
        setSoundEmitter(source);
        setPaused(!paused);
    };

    const toggleSound = (e) => {
        e.stopPropagation();
        setMuted(!muted);
    };

    useEffect(() => {
        if (forcedPause) {
            setPaused(true);
        }
    }, [forcedPause]);

    useEffect(() => {
        if (soundEmitter !== source) {
            setPaused(true);
            setMuted(true);
        }
    }, [soundEmitter]);

    useEffect(() => {
        if (videoRef.current) {
            try {
                if (paused) {
                    videoRef.current.pause();
                } else {
                    if (!forcedPause) {
                        videoRef.current.play();
                    }
                }
            } catch (e) {
                console.log(e);
            }
        }
    }, [paused]);

    useEffect(() => {
        if (videoRef.current) {
            try {
                videoRef.current.muted = muted;
            } catch (e) {
                console.log(e);
            }
        }
    }, [muted]);

    return (
        <div
            className={classes.video}
            onClick={(e) => {
                e.stopPropagation();
            }}
        >
            <div className={clsx(classes.overlay, paused && classes.visible)} onClick={togglePlay}>
                <PlaySVG />
            </div>
            <video
                ref={videoRef}
                muted
                loop
                controlsList={'nodownload nofullscreen'}
                src={source}
                playsInline
                autoPlay={false}
                poster={typeof poster === 'string' ? poster : poster?.src}
                preload="metadata"
            />
            {!paused && (
                <button type="button" className={classes.pause} onClick={togglePlay}>
                    <PauseSVG />
                </button>
            )}
            {!paused && (
                <button
                    type="button"
                    className={clsx(classes.sound, type == 'popup' && classes.popupsound)}
                    onClick={toggleSound}
                >
                    {!muted && <SoundOnSVG />}
                    {muted && <SoundOffSVG />}
                </button>
            )}
        </div>
    );
});
